import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import PAButton from "../../../component/design-system/buttons/PAButton";
import Text from "../../../component/design-system/typography/Text";
import TireSizePreview from "../../static-pages/tire-calculator/TireSizePreview";

function TiresSizeExplanation(props: any) {
  const { t } = useTranslation("category");
  const titleMap = {
    0: t("Diameter"),
    1: t("Width"),
    2: t("Aspect Ratio"),
  };
  const { size } = props;
  const parsedSize = size.replace("-", "/");
  const [width, ratio] = parsedSize.split("/");
  const [aspectRatio, diameter] = ratio.split("R");
  const keysToShow = [diameter, width, aspectRatio];
  const router = useRouter();

  return (
    <div>

      <Text size={4} bold>
        {t("tire_size_explanation", {
          parsedSize, width, diameter, circumference: 3.14 * diameter,
        })}
      </Text>

      <div className="row">

        <div className="col-sm-12 col-md-6 d-flex justify-content-around p-b-10">

          <div>

            <TireSizePreview {...{ calculatedSize: parsedSize }} />
          </div>

          <div className="hidden-xs">

            <Text>{parsedSize}</Text>

            <div>
              {
                keysToShow.map((_, index) => (
                  <div className="d-flex" key={_}>

                    <Text size={6}>

                      {`${titleMap[index] } : `}
                    </Text>

                    <Text bold size={6}>
                      {_}
                    </Text>
                  </div>
                ))
              }
            </div>
          </div>

        </div>

        <div className="col-sm-6 col-md-6">

          <div className="d-flex align-items-center flex-wrap">

            <div className="p-b-10">

              <Text size={4} bold>
                {t("Upsizing wheels or Tires ?")}
              </Text>

              <Text size={6}>
                {t("upsizing_wheel_tire")}
              </Text>
            </div>

            <PAButton
              onClick={() => router.push("/wheels-tires")}
              style={{ width: "100%" }}
            >
              Alternate Sizes
            </PAButton>
          </div>

        </div>

      </div>

    </div>
  );
}

export default TiresSizeExplanation;
